import { axios } from './axios.js';

export async function getColumns(organizationId, projectId = null) {
  try {
    let url = `/custom-columns?organizationId=${organizationId}`;
    if (projectId) {
      url += `&projectId=${projectId}`;
    }

    const res = await axios.get(url);
    return res.data;
  } catch (error) {
    console.error('Error fetching columns:', error);
    return {
      status: 'error',
      error,
    };
  }
}

export async function createColumn(column) {
  try {
    const res = await axios.post('/custom-columns', column);
    return res.data;
  } catch (error) {
    console.error('Error creating column:', error);
    throw error;
  }
}

export async function createColumnsBulk(columns) {
  try {
    const res = await axios.post('/custom-columns/bulk', { columns });
    return res.data;
  } catch (error) {
    console.error('Error creating columns in bulk:', error);
    throw error;
  }
}

export async function updateColumn(columnId, updates) {
  try {
    const res = await axios.put(`/custom-columns/${columnId}`, updates);
    return res.data;
  } catch (error) {
    console.error('Error updating column:', error);
    throw error;
  }
}

export async function deleteColumn(columnId, organizationId, projectId = null) {
  try {
    await axios.delete(`/custom-columns/${columnId}`);
    return {
      status: 'success',
    };
  } catch (error) {
    console.error('Error deleting column:', error);
    throw error;
  }
}

export const updateColumnOrder = async ({ columnOrder }) => {
  const res = await axios.put('/custom-columns/order', { columnOrder });
  return res.data;
};

export const getColumnValues = async (entityType, entityId) => {
  const res = await axios.get(
    `/custom-columns/values/${entityType}/${entityId}`,
  );
  return res.data;
};

export const saveColumnValues = async values => {
  const res = await axios.post('/custom-columns/values', values);
  return res.data;
};

export const updateColumnValue = async (
  columnId,
  entityType,
  entityId,
  value,
  rename = false,
) => {
  const res = await axios.put(
    `/custom-columns/values/${columnId}/${entityType}/${entityId}`,
    { value, rename },
  );
  return res.data;
};
